import React from "react";
import { Redirect } from "react-router-dom";
import { Grid, Segment } from "semantic-ui-react";
import styled from "styled-components";
import PillButton from "../components/common/PillButton";
import { Constants, Paths } from "../Constants";
import BaseComponent from "./BaseComponent";
import AppHeaderSmall from "./common/AppHeaderSmall";
import Footer from "./common/Footer";
import MainContentWrapper from "./common/MainContentWrapper";
import SFCookieConsent from "./common/SFCookieConsent";
import SFLoader from "./common/SFLoader";
import SiteWrapper from "./common/SiteWrapper";
import TabBar from "./common/TabBar";
import TestResult from "./common/TestResult";
import ErrorDisplay from "./ErrorDisplay";
import TestGuideLinesScreen from "./TestGuideLinesScreen";

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;

const CenteredButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
`;

class MyTestsScreen extends BaseComponent {
  constructor() {
    super();
    this.state = {
      testResults: null,
      guidelinesRead: false,
      dataLoaded: false,
      showActivityIndicator: false,
      openTestGuideLines: false,
    };
    this.getTestResults = this.getTestResults.bind(this);
    this.addTestResultFile = this.addTestResultFile.bind(this);
    this.openGuidelines = this.openGuidelines.bind(this);
    this.checkGuidelinesRead = this.checkGuidelinesRead.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  closeModal() {
    this.setState({ openTestGuideLines: false });
  }

  async addTestPDF() {
    if (!(await this.checkLogin())) {
      return;
    }
    /*
    try {
      this.errorManager.reset();
      this.forceUpdate();
      
      const res = await DocumentPicker.getDocumentAsync({
        type: "application/pdf",
      });
      if (res.uri) {
        this.setState({ showActivityIndicator: true });
        await this.addTestResultFile(res.uri);
        this.setState({ showActivityIndicator: false });
      }
    } catch (err) {
      this.errorManager.addError(err.toString());
      this.setState({ showActivityIndicator: false });
      this.forceUpdate();
    }
    */
  }

  openGuidelines() {
    //This probably needs to be a popup
    this.setState({ openTestGuideLines: true });
  }

  async addTestResultFile() {
    if (!(await this.checkLogin())) {
      return;
    }
    this.errorManager.reset();
    this.setState({ showActivityIndicator: true });
    const response = await this.safeFunApi.addTestResultFile(
      this.state.fileName
    );
    this.setState({ fileName: null, showActivityIndicator: false });
    if (!response.data.success) {
      this.errorManager.addError(response.data.consumerMessage);
      this.setState({ fileName: null });
    } else {
      this.getTestResults();
    }
  }

  async componentDidMount() {
    if (!(await this.checkLogin())) {
      return;
    }

    this.setState({ showActivityIndicator: true });
    await this.getTestResults();
    await this.checkGuidelinesRead();
    this.setState({ showActivityIndicator: false });
  }

  async checkGuidelinesRead() {
    const guidelinesRead = window.localStorage.getItem(
      Constants.TESTING_RULES_GUIDELINES_READ_KEY
    );

    if (guidelinesRead === "true") {
      this.setState({ guidelinesRead: true });
    }
  }

  async getTestResults() {
    this.setState({ showActivityIndicator: true });
    try {
      const response = await this.safeFunApi.getTestResults();
      this.setState({ testResults: response.data, dataLoaded: true });
    } catch (err) {
      console.log(err);
      this.errorManager.addError(err.toString());
      this.forceUpdate();
    }
    this.setState({ showActivityIndicator: false });
  }

  render() {
    return (
      <SiteWrapper>
        {this.state.redirectPath ? (
          <Redirect
            to={{
              pathname: this.state.redirectPath,
              search: this.state.redirectSearch,
              state: this.state.redirectState,
            }}
          />
        ) : null}

        <AppHeaderSmall title="My Tests" />
        <SFLoader active={this.state.showActivityIndicator} />
        <MainContentWrapper>
          <TabBar mytests />
          <Wrapper>
            <Grid columns={1} style={{ width: "500px" }}>
              <Grid.Row>
                <Grid.Column>
                  <CenteredButtonWrapper>
                    <PillButton
                      primary
                      style={{ width: "200px", marginTop: 20 }}
                      onClick={this.openGuidelines}
                    >
                      Before You Add
                    </PillButton>
                  </CenteredButtonWrapper>

                  <CenteredButtonWrapper>
                    {this.state.fileName ? (
                      <PillButton
                        onClick={() => {
                          this.addTestResultFile();
                        }}
                        primary
                        style={{ width: "200px" }}
                      >
                        Upload
                      </PillButton>
                    ) : (
                      <input
                        accept=".pdf"
                        type="file"
                        name="file"
                        onChange={(e) => {
                          this.setState({ fileName: e.target.files[0] });
                        }}
                      />
                    )}
                  </CenteredButtonWrapper>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column>
                  <Segment
                    style={{
                      overflow: "auto",
                      maxHeight: 600,
                      border: "none",
                      backgroundColor: "#F7F7F7",
                    }}
                  >
                    <Grid style={{ backgroundcolor: "#F7F7F7" }}>
                      {this.state.testResults
                        ? this.state.testResults.map((testResult) => (
                            <Grid.Row
                              key={testResult.sF_TestResultId}
                              onClick={() => {
                                this.redirect(Paths.TEST_DETAIL, "", {
                                  testResultDetail: testResult,
                                });
                              }}
                              style={{ padding: "5px" }}
                            >
                              <TestResult item={testResult} />
                            </Grid.Row>
                          ))
                        : null}
                    </Grid>
                  </Segment>
                  {this.errorManager.getErrorCount() > 0 ? (
                    <ErrorDisplay errorManager={this.errorManager} />
                  ) : null}
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Wrapper>
        </MainContentWrapper>
        <Footer />
        <TestGuideLinesScreen
          open={this.state.openTestGuideLines}
          closeModal={this.closeModal}
        />
        <SFCookieConsent />
      </SiteWrapper>
    );
  }
}

export default MyTestsScreen;
